import React from 'react';
import MessagesSection from '../../../sections/AdminDashboard/Messaging/Messages';

const Messages = () => {
  return <MessagesSection />;
};

export default Messages;

